import { useSelector } from "react-redux";
import { timeStampToNumberedDateString } from "../../../utils/commonServices";


export default (filesArray, sortQuery) => {
   // const commonReducer = useSelector((state) => state.root.commonReducer);
    // console.log(filesArray)
   // const filesArray = commonReducer.filtered_events;
    let sortedFiles=[]

        if (sortQuery == 'date_added'){
      const sorted = [...filesArray].sort((a, b) => a.created_at > b.created_at ? -1 : 1, );
   sortedFiles = sorted
    }
   
    if (sortQuery == 'start_dates'){
      const sorted = [...filesArray].sort((a, b) =>
    a.start_date > b.start_date ? -1 : 1,
   );
   sortedFiles = sorted
    }


if (sortQuery == 'end_dates'){
    const sorted = [...filesArray].sort((a, b) =>
  a.editor_start_date > b.editor_start_date ? -1 : 1,
 );
 sortedFiles = sorted
  }
    
if(sortQuery == 'a_z'){
  const sorted = [...filesArray].sort((a, b) =>
  a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
 );
 sortedFiles = sorted

  }

  // if(sortQuery == 'can_upload'){
  //   const filtered = filesArray.filter(file => file.flag?.can_upload === true);
  //   sortedFiles = filtered;
  
  //   }

    // if(sortQuery == 'video_uploaded'){
    //   const filtered = filesArray.filter(file =>
    //     file.flag?.internal_revision === true &&
    //     file.flag?.internal_revision_rejected === false &&
    //     file.flag?.can_upload === false
    //   );
    //  sortedFiles = filtered
    
    // }

    // if(sortQuery == 'client_action'){
    //   const filtered = filesArray.filter(file =>
   
    //     file.flag?.editing_cycle_completed === true &&
    //     file.flag?.new_editing_cycle === false
    //   );
    //    sortedFiles = filtered
      
    // }

    // if(sortQuery == 'new_text'){
    //   const filtered = filesArray.filter(file => file.flag?.chat === true);

    //   sortedFiles = filtered;
        
    // }

    
    // if(sortQuery == 'project_complete'){
    //   const filtered = filesArray.filter(file => file.status_type_order == 5);

    //   sortedFiles = filtered;
        
    // }

    
    // if(sortQuery == 'editing_cycle'){
    //   const filtered = filesArray.filter(file => file.editing_cycle_count > 0);

    //   sortedFiles = filtered;
        
    // }

    if(sortQuery == "" || sortQuery == null){
      sortedFiles = [...filesArray]
    }

  
    return [sortedFiles];
  };